import { FC, SVGProps } from "react";

const SelectIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg  enableBackground="new 0 0 24 24" height="512" viewBox="0 0 24 24" width="512" fill="currentcolor" {...props}>
      <g>
        <path d="m7.5 17c-.276 0-.5-.224-.5-.5v-11.5c0-1.103.897-2 2-2s2 .897 2 2v10.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-10.5c0-.552-.448-1-1-1s-1 .448-1 1v11.5c0 .276-.224.5-.5.5z" />
      </g>
      <g>
        <path d="m13.5 16c-.276 0-.5-.224-.5-.5v-4.5c0-.552-.448-1-1-1s-1 .448-1 1c0 .276-.224.5-.5.5s-.5-.224-.5-.5c0-1.103.897-2 2-2s2 .897 2 2v4.5c0 .276-.224.5-.5.5z" />
      </g>
      <g>
        <path d="m16.5 16c-.276 0-.5-.224-.5-.5v-3.5c0-.552-.448-1-1-1s-1 .448-1 1c0 .276-.224.5-.5.5s-.5-.224-.5-.5c0-1.103.897-2 2-2s2 .897 2 2v3.5c0 .276-.224.5-.5.5z" />
      </g>
      <g>
        <path d="m15.5 24h-5.787c-1.683 0-3.419-.733-4.646-1.961-1.354-1.355-2.069-3.288-2.066-5.588.001-1.902 1.592-3.451 3.545-3.451h.954c.276 0 .5.224.5.5s-.224.5-.5.5h-.954c-1.402 0-2.544 1.101-2.545 2.452-.002 2.058.595 3.699 1.773 4.88 1.229 1.23 2.84 1.668 3.939 1.668h5.787c1.93 0 3.5-1.57 3.5-3.5v-6.5c0-.552-.448-1-1-1s-1 .448-1 1c0 .276-.224.5-.5.5s-.5-.224-.5-.5c0-1.103.897-2 2-2s2 .897 2 2v6.5c0 2.481-2.019 4.5-4.5 4.5z" />
      </g>
      <g>
        <path d="m12.5 8.32c-.111 0-.224-.037-.316-.113-.214-.175-.245-.489-.07-.703.579-.71.886-1.576.886-2.504 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 .928.307 1.794.887 2.504.175.214.144.528-.07.703-.213.176-.528.144-.703-.07-.729-.891-1.114-1.976-1.114-3.137 0-2.757 2.243-5 5-5s5 2.243 5 5c0 1.161-.385 2.246-1.113 3.137-.099.121-.242.183-.387.183z" />
      </g>
    </svg>
  );
};

export default SelectIcon;
